// profileExtension.ts
import { clientConnector } from '@games/socket-client'

type ProfileCallback = (error: string | null, response: unknown) => void

/**
 * Расширяет clientConnector для работы с комнатами
 */
export function extendSocketWithStats(): void {
  // Регистрируем один компонент со всеми методами комнаты
  const statsComponent = {
    name: 'stats',
    methods: {
      // Методы для отправки запросов (с ожиданием ответа)
      all: {
        emitEvent: 'stats:getAll',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onAllStatsReceived'
      },
      pve: {
        emitEvent: 'stats:getPvE',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onPvEStatsReceived'
      },
      pvp: {
        emitEvent: 'stats:getPvP',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onPvPStatsReceived'
      }
    }
  }
  
  // Регистрируем компонент без возврата результата
  clientConnector.registerComponent(statsComponent);
}